// client/src/components/agent/actions/ContactFieldsView.jsx
import { useState, useEffect } from 'react';
import theme from '../../../theme';

// MariaDB devuelve la columna JSON `custom` como string; MySQL ya la parsea.
function parseCustom(custom) {
  if (!custom) return {};
  if (typeof custom === 'object') return custom;
  try { return JSON.parse(custom) || {}; } catch { return {}; }
}

export default function ContactFieldsView({ token, contact, onBack, onSaved }) {
  const [rows, setRows] = useState([]);     // campos existentes editables: {key, value}
  const [extras, setExtras] = useState([]); // nuevos: {key, value}
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const custom = parseCustom(contact?.custom);
    setRows(Object.entries(custom).map(([key, value]) => ({ key, value: value == null ? '' : String(value) })));
    setExtras([]);
  }, [contact?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const c = theme.colors;
  const inputStyle = { width: '100%', padding: '6px 8px', background: c.background, color: c.text, border: `1px solid ${c.border}`, borderRadius: 6, fontSize: 13 };

  const save = async () => {
    if (!contact) return;
    setSaving(true);
    const fields = {};
    rows.forEach((r) => { if (r.key.trim()) fields[r.key.trim()] = r.value; });
    extras.forEach((r) => { if (r.key.trim()) fields[r.key.trim()] = r.value; });
    try {
      await fetch(`/api/agent/contacts/${contact.id}/fields`, {
        method: 'PATCH',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ fields }),
      });
      onSaved && onSaved(fields);
    } catch { /* silent */ }
    setSaving(false);
  };

  return (
    <div style={{ padding: 12, color: c.text, overflowY: 'auto' }}>
      <button onClick={onBack} style={{ background: 'none', border: 'none', color: c.primary, cursor: 'pointer', marginBottom: 8 }}>← Atrás</button>
      <h4 style={{ margin: '4px 0 10px' }}>Datos grabados del usuario</h4>
      <div style={{ fontSize: 12, color: c.textMuted, marginBottom: 8 }}>📱 {contact?.id}</div>

      {(rows.length > 0 || extras.length > 0) && (
        <div style={{ display: 'flex', gap: 6, padding: '0 2px 4px', fontSize: 11, fontWeight: 600, color: c.textMuted }}>
          <div style={{ flex: 1 }}>Campo</div>
          <div style={{ flex: 2 }}>Valor</div>
        </div>
      )}

      {rows.map((r, i) => (
        <div key={`r${i}`} style={{ marginBottom: 6, display: 'flex', gap: 6, alignItems: 'center' }}>
          <div style={{ flex: 1, fontSize: 13, color: c.text, wordBreak: 'break-word' }}>{r.key}</div>
          <input style={{ ...inputStyle, flex: 2 }} value={r.value}
            onChange={(e) => setRows((p) => p.map((x, j) => j === i ? { ...x, value: e.target.value } : x))} />
        </div>
      ))}

      {extras.map((r, i) => (
        <div key={`e${i}`} style={{ marginBottom: 6, display: 'flex', gap: 6, alignItems: 'center' }}>
          <input style={{ ...inputStyle, flex: 1 }} placeholder="Nombre del campo" value={r.key}
            onChange={(e) => setExtras((p) => p.map((x, j) => j === i ? { ...x, key: e.target.value } : x))} />
          <input style={{ ...inputStyle, flex: 2 }} placeholder="Valor" value={r.value}
            onChange={(e) => setExtras((p) => p.map((x, j) => j === i ? { ...x, value: e.target.value } : x))} />
        </div>
      ))}

      <button onClick={() => setExtras((p) => [...p, { key: '', value: '' }])}
        style={{ background: 'none', border: `1px dashed ${c.border}`, color: c.primary, borderRadius: 6, padding: '6px 8px', cursor: 'pointer', width: '100%', margin: '6px 0 10px' }}>
        + Agregar campo
      </button>

      <button onClick={save} disabled={saving}
        style={{ background: c.primary, color: '#001018', border: 'none', borderRadius: 6, padding: '8px 10px', cursor: 'pointer', width: '100%', opacity: saving ? 0.6 : 1 }}>
        {saving ? 'Guardando…' : 'Guardar'}
      </button>
    </div>
  );
}
